import { computed, ref, onUnmounted } from 'vue';
import type { WritableComputedRef } from 'vue';
import { storeToRefs } from 'pinia';
import { useNotificationStore } from '@/stores';
import type { NotificationProps } from '@/types/models/common.d';

export const useNotification = () => {
  const store = useNotificationStore();
  const { notification } = storeToRefs(store);

  // このcomposableを呼び出したコンポーネントのマウント状態を追跡
  // アンマウント後の通知操作を防ぐ（グローバル化前の仕様に合わせる）
  const isMounted = ref(true);
  onUnmounted(() => {
    isMounted.value = false;
  });

  /** 通知を表示（既存の通知は上書き） */
  const notify = (props: NotificationProps): void => {
    if (!isMounted.value) return; // アンマウント後は何もしない
    notification.value = props;
  };

  /** 通知を閉じる */
  const closeNotify = (): void => {
    if (!isMounted.value) return; // アンマウント後は何もしない
    notification.value = undefined;
  };

  /** v-snackbarのv-model用 */
  const notificationModelValue: WritableComputedRef<boolean> = computed({
    get: () => Boolean(notification.value),
    set: (value) => {
      if (!value) notification.value = undefined;
    },
  });

  return {
    notify,
    closeNotify,
    notificationModelValue,
    notification: computed(() => notification.value),
  };
};
